'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils.js');

var _featureDetection = require('./featureDetection.js');

var _httpsShim = require('./httpsShim');

var _dataDispatcher = require('./dataDispatcher');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataSender = function () {
    function DataSender(apiUrl) {
        _classCallCheck(this, DataSender);

        this._apiUrl = apiUrl;
    }

    _createClass(DataSender, [{
        key: 'sendData',
        value: function sendData(data) {
            var _this = this;

            var that = this;

            return new Promise(function (resolve, reject) {
                if (!_this._apiUrl) {
                    reject('Koala - Data sender: missing apiUrl');
                }

                data = JSON.stringify(data);

                var utfEightString = unescape(encodeURIComponent(data));
                var encodedData = encodeURIComponent((0, _utils.encodeBase64)(utfEightString));

                if ((0, _featureDetection.isServer)()) {
                    (0, _httpsShim.getHttps)().get(_this._apiUrl + "?data=" + encodedData, function (res) {
                        resolve(data);
                    }).on('error', function (e) {
                        reject(e);
                    });
                } else {
                    if ("string" === typeof encodedData && 4000 <= encodedData.length) {
                        (0, _dataDispatcher.xhrSend)(_this._apiUrl, data);
                        resolve(data);
                    } else {
                        //TODO: write a unit test to see if this works now.
                        (0, _dataDispatcher.beaconSend)(_this._apiUrl, encodedData);
                        resolve(data);
                    }
                }
            });
        }
    }]);

    return DataSender;
}();

exports.default = DataSender;


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/dataSender.js